import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const context = '.single-champagne section:not(.hero)';

if (document.querySelector(context)) {

    let mm = gsap.matchMedia();

    let textArray = gsap.utils.toArray([`${context} h3`, `${context} h5`, `${context} p`, `${context} button`, `${context} .barre`]);
    let barreArray = gsap.utils.toArray([`${context} .barra`]);
    let imgArray = gsap.utils.toArray([`${context} .width-animation`, `${context} .width-animation-reverse`, `${context} .height-animation`, `${context} .height-animation-reverse`]);

    mm.add({
        isMobile: "(max-width: 767px)",
        isDesktop: "(min-width: 768px)"
    }, (animContext) => {
        let { isMobile, isDesktop } = animContext.conditions;
        let offset = isMobile ? 100 : 200;

        gsap.from(`${context}#champagne1 img`, {
            scrollTrigger: {
                trigger: `${context}#champagne1 img`,
                start: "top+=100 bottom",
                end: "bottom+=50 bottom",
                invalidateOnRefresh: true,
                scrub: true,
            },
            x: -250,
            rotate: 10, 
            duration: .5
        });

        gsap.from( `${context}#champagne2 .grid-3 img`, {
            scrollTrigger: {
                trigger: `${context}#champagne2 .grid-3`,
                start: `top bottom-=${offset}`,
                end: 'bottom top',
                once: true,
            },
            opacity: 0,
            duration: .5,
            stagger: .3,
            y: 50,
        });
    
    
        gsap.from( `${context}#champagne3 .grid-2 .blocco`, {
            scrollTrigger: {
                trigger: `${context}#champagne3 .grid-2 .blocco`,
                start: `top bottom-=${offset}`,
                end: 'bottom top',
                once: true,
            },
            opacity: 0,
            duration: .3,
            stagger: .2,
            y: 20,
        });
    
    
        textArray.forEach(text => {
            let textTl = gsap.timeline({
                scrollTrigger: {
                    trigger: text,
                    start: `top bottom-=${offset}`,
                    end: 'bottom top',
                    once: true,
                }
            });
            textTl.from(text, {opacity: 0, duration: 1, y: 20});
        });
    
        barreArray.forEach(barra => {
            let barraTl = gsap.timeline({
                scrollTrigger: {
                    trigger: barra,
                    start: `top bottom-=${offset}`,
                    end: 'bottom top',
                    once: true,
                    onEnter: () => {
                        barra.classList.add('reveal');
                    }
                }
            });
        });

        imgArray.forEach(img => {
            gsap.timeline({
                scrollTrigger: {
                    trigger: img,
                    start: `top bottom-=${offset}`,
                    end: 'bottom top',
                    once: true,
                    onUpdate: self => {
                        self.trigger.style.setProperty('--animWidth', "100%");
                    },
                }
            });
        });
        
    });

}


const parallaxObj = document.querySelectorAll("#champagne6 a");

parallaxObj.forEach(link => {

    let bkgObj = link.children[0].children[0];
    let bottleObj = link.children[0].children[1];
    let xToBottle = gsap.quickTo(bottleObj, "x", {duration: 0.6, ease: "power3"}),
        yToBottle = gsap.quickTo(bottleObj, "y", {duration: 0.6, ease: "power3"}),
        xToBkg = gsap.quickTo(bkgObj, "x", {duration: 0.6, ease: "power3"}),
        yToBkg = gsap.quickTo(bkgObj, "y", {duration: 0.6, ease: "power3"}),
        x = link.getBoundingClientRect().x,
        y = link.getBoundingClientRect().y,
        width = link.getBoundingClientRect().width,
        height = link.getBoundingClientRect().height;

    link.addEventListener("mouseover", e => {
        link.addEventListener("mousemove", e => {
            xToBottle( ((e.clientX - x ) - width / 2) * 0.1  );
            yToBottle( ((e.clientY) - height / 2) * 0.1  );
            xToBkg( ((e.clientX - x ) - height / 2) * (-0.05)  );
            yToBkg( ((e.clientY) - height / 2) * (-0.05)  );
        });
    });

    link.addEventListener("mouseout", e => {
        xToBottle(0);
        yToBottle(0);
        xToBkg(0);
        yToBkg(0);
    });
});

